import { useState, useEffect } from 'react';

const TRESHOLD_MOBILE = 600;
export default  function useResponsive() {
    const isMobile = screen.width < TRESHOLD_MOBILE;

    const maxWidthContainer = isMobile ? '95vh' : 700


    return [isMobile, maxWidthContainer];
}
